export const Templates = [
    {
        id: 1,
        url: "https://celiklerenerji.com/hakkimizda",
        label: "Hakkımızda",
        value: 1,
    },
    {
        id: 2,
        url: "https://celiklerenerji.com/istasyonlar",
        label: "İstasyonlar",
        value: 2,
    },
    {
        id: 3,
        url: "https://celiklerenerji.com/is-ortaklarimiz",
        label: "İş Ortaklarımız",
        value: 3,
    },
    {
        id: 4,
        url: "https://celiklerenerji.com/is-ortaklarimiz",
        label: "İndirme",
        value: 4,
    }
]